import React from 'react';
import { createRoot } from 'react-dom/client';

import GlobalStyles from './global-style';

import PageWrap from './views/pagewrap';

const container = document.getElementById('foot');
const root = createRoot(container);

const element = (
  <div>
    <GlobalStyles />
    <PageWrap />
  </div>
);

root.render(element);
